import { Helmet } from "react-helmet-async";
import { Navigate, useParams } from "react-router-dom";
import { PERSONA_PAGES, AUDIENCES } from "../data/personaContent";
import { SalesTriadSection } from "../components/common/SalesTriadSection";
import { OrderNowBottomCTA } from "../components/common/ServiceOrderBundle";
import {
  PersonaHeader, PersonaHero, StepsBlock, PackagesGrid, MarginCalculator, AgencyPerksBlock, FaqBlock,
} from "../components/persona/PersonaSections";

const CSS = `
@keyframes personaUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: none; } }
.persona-reveal { animation: personaUp .7s cubic-bezier(.2,.7,.2,1) both; }
.persona-delay-1 { animation-delay: .15s; }
`;

export default function PersonaLandingPage({ audience }) {
  const { persona = "jednoducho" } = useParams();
  const page = PERSONA_PAGES[audience]?.[persona];
  if (!page) return <Navigate to={`/pre-${audience}`} replace />;
  const aud = AUDIENCES[audience];
  const isAgency = audience === "agentury";
  const featured = aud.packages.find((p) => p.id === aud.featured);

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white" data-testid={`persona-page-${audience}-${persona}`}>
      <Helmet>
        <title>{page.seoTitle}</title>
        <meta name="description" content={page.seoDesc} />
        <meta property="og:title" content={page.seoTitle} />
        <meta property="og:description" content={page.seoDesc} />
        <meta property="og:image" content={page.image} />
      </Helmet>
      <style>{CSS}</style>
      <PersonaHeader />
      <PersonaHero page={page} isAgency={isAgency} />
      <SalesTriadSection {...page.triad} />
      <StepsBlock steps={aud.steps} />
      {isAgency && <MarginCalculator />}
      <PackagesGrid packages={aud.packages} isAgency={isAgency} />
      {isAgency && <AgencyPerksBlock />}
      <FaqBlock faq={aud.faq} />
      <div className="max-w-5xl mx-auto px-5 sm:px-8 pb-16">
        <OrderNowBottomCTA
          packageId={featured.id}
          priceEur={featured.price}
          interval="mes"
          serviceName={`TopRankPulse ${featured.name}`}
          headline={page.finalHeadline}
          subcopy={page.finalSub}
          testid="persona-final-cta"
        />
      </div>
    </div>
  );
}
